import { useNavigate } from "react-router-dom";

const useNavigation = () => {
  const navigate = useNavigate();

  return {
    navigate: (url, replace = false) => {
      navigate(`/admin/${url}`, {
        replace: replace,
      });
    },
    getUrl: (to) => {
      return `/admin/${to}`;
    },
  };
};

export default useNavigation;
